import { toast } from '@heidi/design-system/toast';
import type { IntlShape } from 'react-intl';
import { backupExtractionFailedMessages } from './backupExtractionFailed.messages';

/** For callers that catch a backup extraction failure and show no recovery prompt. */
export const showBackupExtractionFailedToast = (intl: IntlShape) => {
  toast({
    tone: 'destructive',
    title: intl.formatMessage(backupExtractionFailedMessages.title),
    description: intl.formatMessage(backupExtractionFailedMessages.description),
  });
};
